export const TiposActionTypes = {
  API_RESPONSE_SUCCESS: '@@tipo-incidencias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@tipo-incidencias/API_RESPONSE_ERROR',

  LIST_TIPOS: '@@tipo-incidencias/LIST_TIPOS',
  GET_TIPO: '@@tipo-incidencias/GET_TIPO',
  ADD_TIPO: '@@tipo-incidencias/ADD_TIPO',
  UPDATE_TIPO: '@@tipo-incidencias/UPDATE_TIPO',
  DELETE_TIPO: '@@tipo-incidencias/DELETE_TIPO',

  RESET: '@@tipo-incidencias/RESET'
}
